import { QUES_TYPE } from "../../../../../util/const";
import { SingleSelect } from "../SingleSelect";
import "./styles.css";

const SingleSelectChips = ({ getOptions, responses }) => {
  return <>{getOptions()}</>;
};

export default SingleSelect(SingleSelectChips, QUES_TYPE.SINGLE_SELECT_CHIPS);
